// JS
import './modules/xterm.module.js';
import './modules/notyf.module.js';
import './modules/events.module.js';

// Styles
import './styles/main.css';
import '@xterm/xterm/css/xterm.css';
